import { useMemo } from 'react';
import { AssetListAsset, AssetRenderingProps } from 'src/@types/assets';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

export const useSubaccountAssets = (
	assetList: AssetListAsset[]
): AssetRenderingProps[] => {
	const currentUerAccountState = useDriftAccountStore(
		(s) => s.accounts[s.currentUserKey]
	);

	const assetsWithBalances = useMemo(
		() =>
			assetList.map((asset) => {
				if (!currentUerAccountState) {
					return {
						...asset,
						uiAmount: 0,
					};
				}

				const userBalances = currentUerAccountState.spotBalances ?? [];

				const balance = userBalances.find(
					(b) => b.asset.mint.toString() === asset.mint
				);

				if (balance) {
					return {
						...asset,
						uiAmount: balance.balance.toNum(),
					};
				}

				return {
					...asset,
					uiAmount: 0,
				};
			}),
		[assetList, currentUerAccountState]
	);

	return assetsWithBalances;
};
